import { useMemo } from 'react';

export const useAllLinkIdsMap = ({ links, value }) => {
  const allIdsMap = useMemo(() => {
    const result = {};
    links.forEach((link) => {
      result[link.id] = value;
    });
    return result;
  }, [links]);

  return allIdsMap;
};
